import { EntityRepository, Repository } from "typeorm";
import { LocationDTO } from "./location-dto";
import { Location } from "./loction-entity";

@EntityRepository(Location)
export class LocationRepository extends Repository<Location>{
    convertDtoToEntity(createDto: LocationDTO) {
        throw new Error("Method not implemented.");
    }

}
